module.exports = __webpack_public_path__ + "img/hermon_no.b1920b10.png";